
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ChangeLanguageIconSp from '@/components/ChangeLanguageIconSp.vue';
import ChangeLanguageIconPc from '@/components/ChangeLanguageIconPc.vue';

@Component({
  components: { ChangeLanguageIconSp, ChangeLanguageIconPc }
})
export default class PageHeader extends Vue {
  @Prop({ default: true }) showBackButton!: boolean;

  onBack() {
    // @backがあればemitを優先する
    if (this.$listeners.back) return this.$emit('back');

    // なければhistory.backする
    this.$router.back();
  }

  get showWhiteLogo(): boolean {
    const isConfirmPage = (this.$refs.header as HTMLElement)?.classList.contains('confirm-page');
    return isConfirmPage || false;
  }
}
